import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import s from './TypingIndicator.module.scss';

type Props = {
  classNameModifier?: string;
};

const TypingIndicator: FC<Props> = ({ classNameModifier }) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    <div className={s.dot} />
    <div className={s.dot} />
    <div className={s.dot} />
  </div>
);

export default TypingIndicator;
